<template>
  <div class="container-custom" v-if="downloadDetail">
    <!-- BreadScrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Support Page',
          to: {
            name: 'Support'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'SupportEdit',
            params: {
              id: $route.params.id,
            },
          }
        },
        {
          name: 'Edit Software',
          to: {
            name: 'SupportEdit_B2C_Downloads_SoftwareEdit',
            params: {
              id: $route.params.id,
            },
          },
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯超值軟體</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>

    <!-- block 1 -->
    <div class="block mb-5">
      <!-- Software Name -->
      <label class="form-item d-flex pa-5">
        <h4 class="w-240px mr-5">Software Name</h4>
        <div class="flex-grow-1 my-n2">
          <v-text-field
            v-model="downloadDetail.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Logo -->
      <div class="form-item d-flex pa-5">
        <div class="w-240px mr-5">
          <h4>Logo</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MBf
          </div>
        </div>
        <div>
          <ImgUploader
            :imageUrl.sync="downloadDetail.logo"
            :dir="'support'"></ImgUploader>
        </div>
      </div>
      <!-- 適用產品 -->
      <div class="form-item d-flex pa-5">
        <div class="w-240px mr-5">
          <h4>適用產品</h4>
          <div class="h5 ink-02-medium--text">
            可複選多個產品，會同時呈現於產品頁Download區
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="support-downloads-autocomplete w-248px">
            <MultiSelectWithCheckbox
              v-model="downloadDetail.product_ids"
              :items="products"
              item-value="id"
              item-text="model_name"
            >
            </MultiSelectWithCheckbox>
          </div>
        </div>
      </div>
    </div>

    <!-- block 2 -->
    <div class="block mb-4">
      <PageMenu :sections="sections">
        <component :is="sectionView" :download="downloadDetail"></component>
      </PageMenu>
    </div>

    <!-- page-actions -->
    <div class="page-actions">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import PageMenu from '@/components/PageMenu.vue';
import MultiSelectWithCheckbox from '@/components/Selection/MultiSelectWithCheckbox.vue';
// sections
import Description from '@/views/G_Support/c/G-1-1b-1-1__SupportEdit_B2C_Downloads_SoftwareEdit.vue';
import Files from '@/views/G_Support/c/G-1-1b-1-2__SupportEdit_B2C_Downloads_SoftwareEdit.vue';

export default {
  components: {
    Breadscrumbs,
    ImgUploader,
    PageMenu,
    MultiSelectWithCheckbox,
    // sections
    Description,
    Files,
  },
  data: () => ({
    products: [],
    selectedProducts: '',
    sections: [
      { name: 'Description', component: 'Description' },
      { name: 'Files', component: 'Files' },
    ],
  }),
  computed: {
    ...mapState('support', ['downloadDetail']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    if (this.downloadDetail === null) {
      this.$router.push({
        name: 'Support',
      });
    }
    this.products = await this.allByBu(this.$route.params.id);
  },
  methods: {
    ...mapActions('product', ['allByBu']),
    ...mapActions('support', ['setDownloadDetail']),
    cancelHandler() {
      this.$router.go(-1);
    },
    saveHandler() {
      this.setDownloadDetail(this.downloadDetail);
      this.$router.go(-1);
    },
  },
};
</script>
